import { Component, OnInit, ViewChild } from '@angular/core';
import { AssetModel } from '../asset/asset.model';
import { AssetService } from '../services';
import { rowAnimation, detailExpand } from '../app.animations';
import { plainToClass } from 'class-transformer';
import { MatDialog } from '@angular/material/dialog';
import { AssetDetailsDialogComponent } from '../asset-details-dialog/asset-details-dialog.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';

@Component({
  selector: 'app-asset-list-page',
  templateUrl: './asset-list-page.component.html',
  styleUrls: ['./asset-list-page.component.scss'],
  animations: [
    detailExpand(),
    rowAnimation()
  ],
})
export class AssetListPageComponent implements OnInit {

  displayedColumns = ['_id', 'title', 'description', 'hint', 'action', 'state'];
  // dataSource: AssetModel[] = [];
  dataSource = new MatTableDataSource();
  expandedElement: any | null;

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(assetService: AssetService, public dialog: MatDialog, private router: Router) {
    assetService.list().subscribe(
      (data) => {
        this.dataSource.data = plainToClass(AssetModel, data);
      },
      (error) => {},
      () => {}
    );
  }

  ngOnInit(): void {
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  newAssetFromTemplate(asset: AssetModel) {
    this.router.navigateByUrl('/new', { state: asset });
  }

  openAsset(asset: AssetModel) {
    const dialogRef = this.dialog.open(AssetDetailsDialogComponent, {
      // width: '300px',
      data: asset
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === undefined || result === null) { return; }
      // this.service.post(result).subscribe(
      //   (data) => {
      //     const dataList = this.dataSource.data;
      //     dataList.push(plainToClass(ClassModel, data));
      //     this.dataSource.data = dataList;
      //    },
      //   (error) => {},
      //   () => {}
      // )
    });
  }

}
